import store from '@/store';

export default (to, from, next) => {
    const is_sim_details_allowed = store.getters.is_sim_details_allowed;

    return {
        allow: is_sim_details_allowed,
        redirect: { name: 'not-found' },
    }
};
